import React from "react";
import { cn } from "../../lib/utils";

export function AccountingDocument03({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      className={cn('h-4 w-4', className)}
      {...props}
    >
      <title>accounting-document-03</title>
      <path strokeLinecap="round" strokeLinejoin="round" d="M21.405 12.3608C21.4287 12.2402 21.4255 12.1159 21.3955 11.9967C21.3655 11.8775 21.3095 11.7664 21.2315 11.6714C21.1536 11.5763 21.0555 11.4997 20.9445 11.4471C20.8334 11.3944 20.7121 11.3669 20.5892 11.3667H10.7325C10.5407 11.3663 10.3548 11.2998 10.2064 11.1784C10.0579 11.0569 9.95586 10.8879 9.9175 10.7L9.68667 9.54083C9.6483 9.35288 9.54627 9.18392 9.3978 9.06247C9.24932 8.94102 9.06349 8.87451 8.87167 8.87416H3.5C3.37737 8.87492 3.25641 8.90274 3.14577 8.95563C3.03512 9.00852 2.93751 9.08518 2.85991 9.18013C2.7823 9.27509 2.72661 9.38601 2.69681 9.50497C2.66701 9.62393 2.66383 9.748 2.6875 9.86833L4.84833 20.7058C4.8867 20.8938 4.98873 21.0627 5.1372 21.1842C5.28568 21.3056 5.47151 21.3721 5.66333 21.3725H18.9275C19.1193 21.3721 19.3052 21.3056 19.4536 21.1842C19.6021 21.0627 19.7041 20.8938 19.7425 20.7058C20.0833 18.9917 21 14.39 21.405 12.3608Z"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M5.79667 6.37334L5.81333 3.45667C5.81333 3.23566 5.90113 3.02369 6.05741 2.86741C6.21369 2.71113 6.42565 2.62334 6.64667 2.62334H17.4483C17.6693 2.62334 17.8813 2.71113 18.0376 2.86741C18.1939 3.02369 18.2817 3.23566 18.2817 3.45667L18.2992 8.87334"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.30667 5.11667L15.1717 5.12334"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12.0467 7.62334H15.1717"/>
    </svg>
  )
} 
